import { useState } from 'react';

export function useLocalStorage() {

  const [signupWithinServiceHours, setSignupWithinServiceHoursValue] = useState(getBoolean('signup-within-service-hours'));
  const [isWhatsappClicked, setIsWhatsappClicked] = useState(getBoolean('new-customer-whatsapp-clicked'));
  const [onboardingCompleted, setOnboardingCompletedValue] = useState(getBoolean('onboarding-completed'));
  const [folloupNotification, setFolloupNotificationValue] = useState(getBoolean('followup-notifications'));

  function setSignupWithinServiceHours(value: boolean) {
    setValue('signup-within-service-hours', value.toString());
    setSignupWithinServiceHoursValue(value);
  }

  function setWhatsappClicked(value: boolean) {
    setValue('new-customer-whatsapp-clicked', value.toString());
    setIsWhatsappClicked(value);
  }

  function setOnboardingCompleted(value: boolean) {
    setValue('onboarding-completed', value.toString());
    setOnboardingCompletedValue(value);
  }

  function setFolloupNotification(value: boolean) {
    setValue('followup-notifications', value.toString());
    setFolloupNotificationValue(value);
  }

  return {
    signupWithinServiceHours,
    isWhatsappClicked,
    onboardingCompleted,
    folloupNotification,
    setSignupWithinServiceHours,
    setWhatsappClicked,
    setOnboardingCompleted,
    setFolloupNotification
  };
}

const getBoolean = (key: string) => getValue(key, (value) => value === 'true');

// const getDate = (key: string) => getValue(key, (value) => new Date(value));
// const getString = (key: string) => getValue(key, (value) => value);
// const getNumber = (key: string) => getValue(key, parseInt);
// const getFloat = (key: string) => getValue(key, parseFloat);
// const getJson = <T>(key: string) => getValue<T>(key, JSON.parse);

function getValue<T>(key: string, parse: (value: string) => T): T | undefined {
  
  const value = localStorage.getItem(key);
  
  if (!value) return undefined;

  try {
    return parse(value);
  } catch (error) {
    console.error('Error getting localStorage value:', key, error);
    return undefined;
  }
}

function setValue(key: string, value: any) {
  localStorage.setItem(key, value);
}
